import * as React from 'react';
export const useClientSideRendering = () => {
    const [isClient, setIsClient] = React.useState(false);
    React.useEffect(() => {
        setIsClient(true);
    }, []);
    return { isClient };
};
